var e={nextArrowLabel:"Next slide",prevArrowLabel:"Previous slide",getSlideLabel:function(e,r){return"".concat(e," of ").concat(r)}};export{e as emblaCarouselTranslations};
